import { InjectionToken, Provider } from '@angular/core';
import { Observable, of } from 'rxjs';

import { IAiInterceptor } from './components/ai-chatbox/ai-chatbox.interceptor';

export const AI_API_ROOT = new InjectionToken<Observable<string>>('API_ROOT');
export const AI_API_HEADERS = new InjectionToken<Observable<object>>('AI_API_HEADERS');
export const AI_MESSAGES_INTERCEPTOR = new InjectionToken<IAiInterceptor>('AI_INTERCEPTOR');
export const AI_CURRENT_USER = new InjectionToken<Observable<any>>('CURRENT_USER');
export const AI_CURRENT_USER_AVATAR = new InjectionToken<Observable<any>>('CURRENT_USER_AVATAR');
export const AI_ASSISTANT_AVATAR = new InjectionToken<string>('AI_ASSISTANT_AVATAR', { factory: () => '/assets/images/ava_64.png' });
export const AI_INTRO_TEXT = new InjectionToken<Observable<string>>('AI_INTRO_TEXT', { factory: () => of('') });

export const provideAIChat = (opts: {
    apiRoot: any,
    apiHeaders: any,
    interceptor: any,
    selectCurrentUser: any,
    selectCurrentUserAvatar: any,
    assistantAvatar: any,
}): Provider[] => [
    {
        provide: AI_API_ROOT,
        useExisting: opts.apiRoot,
    },
    {
        provide: AI_API_HEADERS,
        useExisting: opts.apiHeaders,
    },
    {
        provide: AI_CURRENT_USER,
        useExisting: opts.selectCurrentUser,
    },
    {
        provide: AI_CURRENT_USER_AVATAR,
        useExisting: opts.selectCurrentUser,
    },
    {
        provide: AI_MESSAGES_INTERCEPTOR,
        useExisting: opts.interceptor,
    },
    {
        provide: AI_ASSISTANT_AVATAR,
        useExisting: opts.assistantAvatar,
    },
]

export const provideTestingAIChat = (opts?: {
    apiRoot: any,
    apiHeaders: any,
    interceptor: any,
    selectCurrentUser: any,
    selectCurrentUserAvatar: any,
    assistantAvatar: any,
}): Provider[] => [
	{
			provide: AI_API_ROOT,
			useFactory: () => opts?.apiRoot || of({}),
	},
	{
			provide: AI_API_HEADERS,
			useFactory: () => opts?.apiHeaders || of({}),
	},
	{
		provide: AI_MESSAGES_INTERCEPTOR,
		useFactory: () => opts?.interceptor || of({}),
	},
	{
			provide: AI_CURRENT_USER,
			useFactory: () => opts?.selectCurrentUser || of({}),
	},
	{
			provide: AI_CURRENT_USER_AVATAR,
			useFactory: () => opts?.selectCurrentUserAvatar || of({}),
	},
	{
			provide: AI_ASSISTANT_AVATAR,
			useFactory: () => opts?.apiHeaders || of({}),
	},
]
